import {GlobalService} from '../../../services/global.service';
import {ToastsService} from '../../../services/toasts.service';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {environment} from '../../../../environments/environment.prod';
import {ConfirmDialogComponent} from '../../confirm-dialog/confirm-dialog';
import {ReplaySubject, Subject} from 'rxjs';
import {MatSelect} from '@angular/material/select';
import {takeUntil} from 'rxjs/operators';
import {MatStepper} from '@angular/material/stepper';
import {AngularFirestore} from '@angular/fire/firestore';
import {ProjectsService} from '../../../services/projects.service';

@Component({
    selector: 'app-onboarding-user',
    templateUrl: './onboarding-user.component.html',
    styleUrls: ['./onboarding-user.component.scss']
})
export class OnboardingUserComponent implements OnInit, OnDestroy {

    // TODO make departments match onboarding form more, across both AMD keys
        // 138325 only uses OFFICE (as a global catch all)
            // talk to Susan to see if we can update these to PSYCHIATRY and PSYCHOLOGICAL SERVICES
        // 133003 uses all of them, but only PSYCHIATRY and PSYCHOLOGICAL SERVICES are needed

    projects = [];
    loadingProjects = false;
    projectsSubscription = null;

    userCreate: FormGroup;
    columnAndProviderSettings: FormGroup;
    columnSettings: FormGroup;
    office_codes = ['133003', '138325'];

    departments = [];
    roles = [];
    role_to_columns = {};
    hloc_columns = [];
    users = [];
    column_providers = [];
    columns = [];
    providers = [];
    unassignedProviders = [];
    activeProviders = [];
    activePrescribers = [];
    exampleUsers = [];

    // TODO move this to its own component so it has change detection that's faster
    steps = [];

    generateUsernameWarning = '';

    amdProviderRoles = environment.amdProviderRoles;
    amdCommonRoles = environment.amdCommonRoles;
    amdPrescriberRoles = environment.amdPrescriberRoles;

    initialLoadComplete = false;

    newUserPassesVerification = false;
    shouldShowVerifyNewUser = false;

    allColumnsInOfficeKey = [];
    allProvidersInOfficeKey = [];
    allColumnProvidersInOfficeKey = []; // filtered by selected license key

    projectFilterCtrl: FormControl = new FormControl();
    filteredProjects: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
    @ViewChild('selectProject', { static: true }) selectProject: MatSelect;
    project: FormControl = new FormControl(null);

    columnsFilterCtrl: FormControl = new FormControl();
    filteredColumns: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
    @ViewChild('multiSelect', { static: true }) multiSelect: MatSelect;

    familyTreeProvidersFilterCtrl: FormControl = new FormControl();
    filteredFamilyTreeProviders: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
    @ViewChild('multiSelectProviders', { static: true }) multiSelectProviders: MatSelect;
    familyTreeProviders: FormControl = new FormControl([]);

    superviseesProvidersFilterCtrl: FormControl = new FormControl();
    filteredSuperviseesProviders: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
    @ViewChild('multiSelectProvidersSupervisees', { static: true }) multiSelectProvidersSupervisees: MatSelect;
    superviseesProviders: FormControl = new FormControl([]);

    supervisorProviderFilterCtrl: FormControl = new FormControl();
    filteredSupervisorProviders: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
    @ViewChild('multiSelectProvidersForSupervisor', { static: true }) multiSelectProvidersForSupervisor: MatSelect;
    supervisorProvider: FormControl = new FormControl(null);

    ehrPreferencesTemplateCtrl: FormControl = new FormControl({value: null, disabled: true});
    ehrPreferencesTemplates: any[] = [];

    /** Subject that emits when the component has been destroyed. */
    protected _onDestroy = new Subject<void>();

    openConfirmDialogRef: MatDialogRef<ConfirmDialogComponent>;

    appliedColumnRules = [];
    appliedColumnRulesSum = 0;
    appliedProviderRules = [];
    appliedProviderRulesSum = 0;

    affectedUsers = [];

    role_to_column_needs = {
        // Director
        265: ['all'],
        266: ['all'],

        // THERAPIST
        231: ['self', 'hide_future_columns', 'supervisees', 'supervisor'],
        241: ['self', 'hide_future_columns', 'supervisees', 'supervisor'],

        // THERAPIST (Intern)
        274: ['self', 'hide_future_columns', 'supervisor'],

        // PHP/IOP INTAKE
        294: ['self', 'others_in_same_role', 'php_iop_columns', 'hide_future_columns'],
        299: ['self', 'others_in_same_role', 'php_iop_columns', 'hide_future_columns'],

        // PHP/IOP THERAPIST
        296: ['self', 'php_iop_columns', 'hide_future_columns', 'supervisees', 'supervisor'],
        298: ['self', 'php_iop_columns', 'hide_future_columns', 'supervisees', 'supervisor'],

        // PRESCRIBERS
        234: ['self', 'others_in_family_tree', 'hide_future_columns'],
        226: ['self', 'others_in_family_tree', 'hide_future_columns'],
        293: ['self', 'others_in_family_tree', 'hide_future_columns'],
        223: ['self', 'others_in_family_tree', 'hide_future_columns'],
        297: ['self', 'others_in_family_tree', 'hide_future_columns'],

        // TMS COORDINATOR
        // TODO limit to 1 column + multiple providers instead?
        290: ['all'],
        291: ['all'],

        // PCC
        222: ['all'],

        // PM
        229: ['all'],

        // Admin
        217: ['all'],

        // Marketing
        275: ['all'],
        278: ['all'],

        // Billing
        224: ['all'],
    };

    role_to_ehr_preferences_template = {
        '133003': {
            222: 12,
            229: 12,
            217: 12,
            291: 15,
            294: 6,
            296: 6,
            231: 2,
            274: 2,
            265: 2,
            234: 10,
            226: 10,
            293: 10,
            275: 12,
            224: 12,
        },
        '138325': { // TODO check chat with emma and susan and ethan to see what pref templates they want to create and update here
            // '222': 'PCC',
            // '229': 'Practice Manager',
            // '217': 'Admin',
            // '290': 'TMS Coordinator',
            // '299': 'PHP/IOP Intake',
            // '298': 'PHP/IOP Therapist',
            // '241': 'Therapist',
            // '266': 'Director',
            // '223': 'Psychiatrist',
            // '226': 'APP',
            // '297': 'APP (Lead)',
            // '278': 'Marketing',
            // '224': 'Billing',
        },
    };

    @ViewChild('stepper') stepperRef: MatStepper;

    constructor(public globalService: GlobalService,
                public dialog: MatDialog,
                private http: HttpClient,
                private toastsService: ToastsService,
                private afs: AngularFirestore,
                private _formBuilder: FormBuilder,
                private projectsService: ProjectsService) {
    }

    onChangeOfficeCode(reset = true) {
        console.log('onChangeOfficeCode', this.userCreate.controls['office_code'].value);
        if (reset) {
            this.userCreate.controls['roleid'].setValue(null);
            this.userCreate.controls['departmentid'].setValue(null);
            this.userCreate.controls['clinicalproviderid'].setValue(null);
        }

        if (this.userCreate.controls['office_code'].value) {
            this.userCreate.controls['roleid'].enable();
            this.userCreate.controls['departmentid'].enable();

            // enable all column settings fields
            this.initColumnSettings();

        }
        this.onChangeRole();
    }

    initColumnSettings() {
        const office_code = Number(this.userCreate.controls['office_code'].value);

        this.allColumnsInOfficeKey = this.columns
            .filter(column => column.LicenseKey === office_code);
        this.allColumnsInOfficeKey.sort((a, b) => a.name.localeCompare(b.name));

        this.allProvidersInOfficeKey = this.providers
            .filter(provider => provider.LicenseKey === office_code);
        this.allProvidersInOfficeKey.sort((a, b) => a.name.localeCompare(b.name));

        console.log(this.allColumnsInOfficeKey, this.allProvidersInOfficeKey);

        // TODO if this.column_providers have null Columns or Null Providers, what's the risk?
        // TODO Tania example where Column exists and needs to be restricted but Provider does not exist yet
        this.allColumnProvidersInOfficeKey = this.column_providers
            .filter(provider => provider.LicenseKey === office_code);
        this.activePrescribers = this.activePrescribers
            .filter(provider => provider.LicenseKey === office_code);
        this.allColumnProvidersInOfficeKey.sort((a, b) => a.ColumnHeading.localeCompare(b.ColumnHeading));

        this.filteredColumns.next(this.allColumnProvidersInOfficeKey.slice());
        this.filteredFamilyTreeProviders.next(this.activePrescribers.slice());
        this.filteredSupervisorProviders.next(this.activeProviders.slice().filter(prov => prov.LicenseKey === office_code));
        this.filteredSuperviseesProviders.next(this.activeProviders.slice().filter(prov => prov.LicenseKey === office_code));

    }

    prettyPrintRule(rule: string) {
        // this function is used to pretty print the applied rule
        // a rule is snake_case and we want to convert it to Title Case
        return rule.split('_').map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }).join(' ');
    }

    calculateColumnAndProviderSettings() {
        // first, set autorestrictschedulercolumns based on hide_future_columns
        // also set allehrproviders and allehrcolumns to true if hide_future_columns is false
        if (this.columnSettings.controls['hide_future_columns'].value) {
            this.columnAndProviderSettings.controls['autorestrictschedulercolumns'].setValue(true);
            this.columnAndProviderSettings.controls['allehrproviders'].setValue(false);
            this.columnAndProviderSettings.controls['allehrcolumns'].setValue(false);
        } else {
            this.columnAndProviderSettings.controls['autorestrictschedulercolumns'].setValue(false);
            this.columnAndProviderSettings.controls['allehrproviders'].setValue(true);
            this.columnAndProviderSettings.controls['allehrcolumns'].setValue(true);
        }

        const selectedColumns = [];
        const selectedProviders = [];
        const appliedRules = [];

        // ALL
        if (this.columnSettings.controls['all'].value) {
            this.allColumnsInOfficeKey.forEach(column => {
                selectedColumns.push(column.id);
            });
            this.allProvidersInOfficeKey.forEach(provider => {
                selectedProviders.push(provider.id);
            });
            appliedRules.push({ 'rule': 'all', 'type': 'columns', 'size': this.allColumnsInOfficeKey.length });
            appliedRules.push({ 'rule': 'all', 'type': 'providers', 'size': this.allProvidersInOfficeKey.length });
        } else {
            // SELF, find by matching clinicalproviderid to column with same Provider_UID
            if (this.columnSettings.controls['self'].value) {
                const providerUid = this.userCreate.controls['clinicalproviderid'].value;
                const column = this.allColumnProvidersInOfficeKey.find(col => col.Provider_UID === providerUid);
                if (column) {
                    selectedColumns.push(column.ColumnHeading_UID);
                    selectedProviders.push(column.Provider_UID);
                    appliedRules.push({ 'rule': 'self', 'type': 'columns', 'size': 1 });
                    appliedRules.push({ 'rule': 'self', 'type': 'providers', 'size': 1 });
                } else {
                    // if no column found, show error in appliedRule
                    appliedRules.push({ 'rule': 'self', 'type': 'columns', 'size': 0 });
                    appliedRules.push({ 'rule': 'self', 'type': 'providers', 'size': 0 });
                }
            }

            // OTHERS IN SAME ROLE
            if (this.columnSettings.controls['others_in_same_role'].value) {
                // find all columns with the same roleid as the user
                const roleId = this.userCreate.controls['roleid'].value;
                // use role_to_columns to find the columns that match the roleId
                const columns = this.role_to_columns[roleId];
                // console.log(this.role_to_columns);
                let columns_added = 0;
                let providers_added = 0;
                if (columns) {
                    columns.forEach(column => {
                        // only add column if it's in the right officekey
                        const columnObj = this.allColumnProvidersInOfficeKey.find(col => col.ColumnHeading_UID === column);
                        if (columnObj) {
                            if (columnObj.ColumnHeading_UID) {
                                selectedColumns.push(columnObj.ColumnHeading_UID);
                                columns_added++;
                            }
                            if (columnObj.Provider_UID) {
                                selectedProviders.push(columnObj.Provider_UID);
                                providers_added++;
                            }
                        }
                    });
                }
                appliedRules.push({'rule': 'others_in_same_role', 'type': 'columns', 'size': columns_added, 'has_issue': columns_added !== providers_added });
                appliedRules.push({ 'rule': 'others_in_same_role', 'type': 'providers', 'size': providers_added, 'has_issue': columns_added !== providers_added });
            }

            // PHP IOP COLUMNS
            // do not have any providers associated with them
            if (this.columnSettings.controls['php_iop_columns'].value) {
                // a column is PHP or IOP if it contains ' PHP ' or ' IOP ' in the ColumnHeading
                const phpIopColumns = this.allColumnProvidersInOfficeKey
                    .filter(column => column.ColumnHeading.includes(' PHP ') || column.ColumnHeading.includes(' IOP ') || column.ColumnHeading.includes('PHP/IOP ASSESSMENTS'));
                phpIopColumns.forEach(column => {
                    selectedColumns.push(column.ColumnHeading_UID);
                });
                appliedRules.push({ 'rule': 'php_iop_columns', 'type': 'columns', 'size': phpIopColumns.length, 'has_issue': false });
            }

            // ADD FAMILY TREE (prescribers only)
            if (this.columnSettings.controls['others_in_family_tree'].value) {
                // familyTreeProviders is the control that is a list of Provider_UIDs
                // we need to find the columns that match these. one Provider_UID can match multiple columns
                const selectedFamilyTreeProviders = this.familyTreeProviders.value;
                // find all columns that match the selected providers
                const familyTreeColumns = this.allColumnProvidersInOfficeKey
                    .filter(column => selectedFamilyTreeProviders.includes(column.Provider_UID));
                // add the ColumnHeading_UIDs to selectedColumns
                let columns_added = 0;
                let providers_added = 0;
                familyTreeColumns.forEach(column => {
                    if (column.ColumnHeading_UID) {
                        selectedColumns.push(column.ColumnHeading_UID);
                        columns_added++;
                    }
                    if (column.Provider_UID) {
                        selectedProviders.push(column.Provider_UID);
                        providers_added++;
                    }
                });
                appliedRules.push({ 'rule': 'others_in_family_tree', 'type': 'columns', 'size': familyTreeColumns.length, 'has_issue': columns_added !== providers_added });
                appliedRules.push({ 'rule': 'others_in_family_tree', 'type': 'providers', 'size': familyTreeColumns.length, 'has_issue': columns_added !== providers_added });
            }

            // ADD SUPERVISEES
            if (this.columnSettings.controls['supervisees'].value) {
                // supervisees is the control that is a list of Provider_UIDs
                // we need to find the columns that match these. one Provider_UID can match multiple columns
                const selectedSuperviseesProviders = this.superviseesProviders.value;
                // find all columns that match the selected providers
                const superviseesColumns = this.allColumnProvidersInOfficeKey
                    .filter(column => selectedSuperviseesProviders.includes(column.Provider_UID));
                // add the ColumnHeading_UIDs to selectedColumns
                let columns_added = 0;
                let providers_added = 0;
                superviseesColumns.forEach(column => {
                    if (column.ColumnHeading_UID) {
                        selectedColumns.push(column.ColumnHeading_UID);
                        columns_added++;
                    }
                    if (column.Provider_UID) {
                        selectedProviders.push(column.Provider_UID);
                        providers_added++;
                    }
                });
                appliedRules.push({ 'rule': 'supervisees', 'type': 'columns', 'size': superviseesColumns.length, 'has_issue': columns_added !== providers_added });
                appliedRules.push({ 'rule': 'supervisees', 'type': 'providers', 'size': superviseesColumns.length, 'has_issue': columns_added !== providers_added });
            }
        }

        // remove duplicates
        const uniqueSelectedColumns = [...new Set(selectedColumns)];
        const uniqueSelectedProviders = [...new Set(selectedProviders)];
        // calculate restricted columns
        const restrictedColumns = this.allColumnProvidersInOfficeKey
            .filter(column => !uniqueSelectedColumns.includes(column.ColumnHeading_UID))
            .map(column => column.ColumnHeading_UID);

        // SET FINAL VALUES
        this.columnAndProviderSettings.controls['columnlist'].setValue(uniqueSelectedColumns);
        this.columnAndProviderSettings.controls['restrictedcolumnlist'].setValue(restrictedColumns);
        this.columnAndProviderSettings.controls['providerlist'].setValue(uniqueSelectedProviders);

        this.appliedColumnRules = appliedRules.filter(rule => rule.type === 'columns');
        this.appliedColumnRulesSum = 0;
        this.appliedColumnRules.forEach(rule => {
            this.appliedColumnRulesSum += rule.size;
        });

        this.appliedProviderRules = appliedRules.filter(rule => rule.type === 'providers');
        this.appliedProviderRulesSum = 0;
        this.appliedProviderRules.forEach(rule => {
            this.appliedProviderRulesSum += rule.size;
        });
    }

    passwordChanged() {
        // update all passwords to match
        this.userCreate.controls['confirmpassword'].setValue(this.userCreate.controls['password'].value);
        this.userCreate.controls['signingpassword'].setValue(this.userCreate.controls['password'].value);
        this.userCreate.controls['confirmsigningpassword'].setValue(this.userCreate.controls['password'].value);
    }

    onValidateNewUser(e) {
        // console.log(e);
        this.newUserPassesVerification = e;
    }

    updateEhrPreferencesTemplateFromRole() {
        const roleId = this.userCreate.controls['roleid'].value;
        // set the EHR preferences template based on the role
        const defaultEhrPreferencesTemplateId = this.role_to_ehr_preferences_template
            [this.userCreate.controls['office_code'].value][roleId];
        if (defaultEhrPreferencesTemplateId) {
            this.ehrPreferencesTemplateCtrl.setValue(defaultEhrPreferencesTemplateId);
        } else {
            this.ehrPreferencesTemplateCtrl.setValue(null);
        }
    }

    onChangeRole() {
        const roleId = this.userCreate.controls['roleid'].value;
        // find all users whose roleid is roleId
        this.shouldShowVerifyNewUser = false;
        if (roleId) {
            // set admin type based on role
            if (roleId === 229) {
                // practice manager is limited
                this.userCreate.controls['adminType'].setValue('limited');
            } else if (roleId === 217) {
                // admin is full
                this.userCreate.controls['adminType'].setValue('full');
            } else {
                this.userCreate.controls['adminType'].setValue('none');
            }
            this.updateAdminFields();

            // if role is a provider, require connecting a provider to this user directly
            if (this.amdProviderRoles.includes(roleId)) {
                // if role is a provider, require provider fields
                this.userCreate.controls['clinicalproviderid'].setValidators([Validators.required]);
                this.userCreate.controls['clinicalproviderid'].enable();
                this.shouldShowVerifyNewUser = true;
            } else {
                this.userCreate.controls['clinicalproviderid'].clearValidators();
                this.userCreate.controls['clinicalproviderid'].disable();
                this.userCreate.controls['clinicalproviderid'].setValue(null);
            }

            // set example users based on role so team knows if they picking correct role
            const users = this.users.filter(user => user.roleid === roleId);
            this.exampleUsers = users.map(user => this.titleCase(user.fullname));
        } else {
            this.userCreate.controls['clinicalproviderid'].disable();
            this.exampleUsers = [];
        }

        this.setDefaultsForColumnSettings(roleId);
    }

    setDefaultsForColumnSettings(roleId) {
        // find roleId in role_to_column_needs, and the value is an array of form controls to set to true
        // start by setting all to false
        Object.keys(this.columnSettings.controls).forEach(control => {
            this.columnSettings.controls[control].setValue(false);
        });

        if (roleId) {
            const columnSettings = this.role_to_column_needs[roleId];
            if (columnSettings) {
                columnSettings.forEach(control => {
                    this.columnSettings.controls[control].setValue(true);
                });
            } else {
                this.toastsService.showSnackBar('No definitions found for this role, notify Tavan', 'error', 5000);
            }
        }
    }

    titleCase(str) {
        return str.toLowerCase().split(' ').map(function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }).join(' ');
    }

    generateUsername() {
        this.generateUsernameWarning = '';
        if (this.userCreate.controls['fullname'].value) {
            const fullname = this.userCreate.controls['fullname'].value;
            // username is first letter of first name + last name, all lowercase, and only up to 12 characters
            const firstName = fullname.split(' ')[0];
            const lastName = fullname.split(' ')[1];
            const username = firstName.charAt(0).toLowerCase() + lastName.toLowerCase();
            // remove any special characters
            const regex = /[^a-zA-Z0-9]/g;
            let usernameCleaned = username.replace(regex, '');
            // make sure username is not longer than 12 characters
            if (usernameCleaned.length > 12) {
                usernameCleaned = usernameCleaned.substring(0, 12);
            }

            const existingUser = this.users.find(
                user => user.username.toLowerCase() === usernameCleaned
                    && user.LicenseKey === Number(this.userCreate.controls['office_code'].value));

            if (existingUser) {
                console.warn('Username already exists, adding number to end of username');
                this.generateUsernameWarning = 'Username already exists, try creating a custom username instead';
                this.userCreate.controls['username'].setValue('');
            } else {
                this.userCreate.controls['username'].setValue(usernameCleaned);
            }
        }
    }

    resetUserCreateForm() {
        // this.userCreate.reset();
        // this.columnAndProviderSettings.reset();
        // this.columnSettings.reset();
        // this.userCreate.controls['roles'].disable();
        // this.userCreate.controls['create_column'].disable();
        // this.userCreate.controls['merge_roles'].disable();
        // this.userCreate.controls['column_name'].disable();
        // this.userCreate.controls['page_id'].disable();
        // this.userCreate.controls['facility_id'].disable();
    }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    generateTemporaryPassword() {
        const date = new Date();
        const year = date.getFullYear();
        return 'Clarity' + year + '!';
    }

    updateAdminFields() {
        // for full admin, admin = true, adminType = 'full', adminLimited = false
        // for user admin, admin = false, adminType = 'limited', adminLimited = true
        // for no admin, admin = false, adminType = 'none', adminLimited = false
        const adminType = this.userCreate.controls['adminType'].value;
        if (adminType === 'full') {
            this.userCreate.patchValue({
                admin: true,
                adminLimited: false,
            });
        } else if (adminType === 'limited') {
            this.userCreate.patchValue({
                admin: false,
                adminLimited: true,
            });

        } else {
            this.userCreate.patchValue({
                admin: false,
                adminLimited: false,
            });
        }
    }

    // updateUserType() {
    //     // PM, EHR, Both to determine userType and clinicaluser and ehronly values
    //     // userType // TODO can be ehr (clinicaluser true, ehronly true), clinical (clinicaluser true, ehronly false), pm (clinicaluser false, ehronly false)
    //     const userType = this.userCreate.controls['clinicaluser'].value ? (this.userCreate.controls['ehronly'].value ? 'ehr' : 'clinical') : 'pm';
    //     this.userCreate.patchValue({
    //         userType: userType,
    //     });
    //     console.log(this.userCreate.getRawValue());
    // }

    async ngOnInit() {
        const tempPassword = this.generateTemporaryPassword();
        this.userCreate = this._formBuilder.group({
            office_code: [null, Validators.required],
            departmentid: [{value: null, disabled: true}, Validators.required],
            roleid: [{value: null, disabled: true}, Validators.required],
            clinicalproviderid: [{value: null, disabled: true}],
            password: [{value: tempPassword, disabled: true}, Validators.required],
            confirmpassword: [{value: tempPassword, disabled: true}, Validators.required],
            signingpassword: [{value: tempPassword, disabled: true}, Validators.required],
            confirmsigningpassword: [{value: tempPassword, disabled: true}, Validators.required],

            admin: [{value: false, disabled: true}, Validators.required],
            adminType: [{value: 'none', disabled: true}, Validators.required],
            adminLimited: [{value: false, disabled: true}, Validators.required],

            clinicaluser: [{value: true, disabled: true}, Validators.required],
            ehronly: [{value: false, disabled: true}, Validators.required],
            userType: [{value: 'clinical', disabled: true}, Validators.required],

            fullname: [{value: null, disabled: false}, Validators.required],
            email: [{value: null, disabled: false}, [Validators.required, Validators.email]],
            username: [{value: null, disabled: false}, Validators.required],
        });

        this.columnAndProviderSettings = this._formBuilder.group({
            columnlist: [],
            providerlist: [],
            restrictedcolumnlist: [],

            allehrproviders: [{value: false, disabled: true}],
            allehrcolumns: [{value: false, disabled: true}],
            autorestrictschedulercolumns: [{value: true, disabled: true}],
        });

        this.columnSettings = this._formBuilder.group({
            all: [{value: false, disabled: true}],

            self: [{value: false, disabled: true}],
            others_in_same_role: [{value: false, disabled: true}],
            others_in_family_tree: [{value: false, disabled: true}],
            supervisees: [{value: false, disabled: true}],
            supervisor: [{value: false, disabled: true}],
            php_iop_columns: [{value: false, disabled: true}],

            hide_future_columns: [{value: true, disabled: true}],
        });

        await this.loadAMDSettingsInParallel();
        this.loadProjects();
    }

    loadProjects() {
        this.loadingProjects = true;
        const twoYearsAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 2));
        let projectsCollection;
        projectsCollection = this.afs.collection<any>('projects', ref =>
            ref.where('created', '>', twoYearsAgo).where('archived', '==', false));

        this.projectsSubscription = projectsCollection.valueChanges({idField: 'id'}).subscribe((projects) => {
            // only keep projects that have "onboarding" in the template string
            projects = projects.filter(project => project.template && project.template.toLowerCase().includes('onboarding'));
            // sort projects by last name
            projects.sort((a, b) => {
                const nameA = a.last_name.toLowerCase();
                const nameB = b.last_name.toLowerCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });
            this.projects = projects;
            this.setupSelectProject();
            this.loadingProjects = false;
        }, error => {
            this.toastsService.showSnackBar(error, 'error', 5000);
        });
    }

    // listenForChangesToSelectedColumns() {
    //     // create an array of all formcontrols for column settings
    //     const columnSettingsFormControls = Object.keys(this.columnSettings.controls).map(control => {
    //         return this.columnSettings.controls[control].valueChanges.pipe(distinctUntilChanged());
    //     });
    //
    //     merge(...columnSettingsFormControls).subscribe(
    //         (value) => {
    //             console.log('Value changed:', value);
    //             this.setSelectedColumnsBasedOnSettings();
    //         }
    //     );
    // }

    // listenForChangesToUserType() {
    //     // if ehronly or clinicaluser change, update userType
    //     this.userCreate.controls['ehronly'].valueChanges
    //         .pipe(takeUntil(this._onDestroy))
    //         .subscribe(() => {
    //             this.updateUserType();
    //         });
    //     this.userCreate.controls['clinicaluser'].valueChanges
    //         .pipe(takeUntil(this._onDestroy))
    //         .subscribe(() => {
    //             this.updateUserType();
    //         });
    // }

    setupMultiSelectColumns() {
        // load the initial list
        this.filteredColumns.next(this.allColumnProvidersInOfficeKey.slice());

        // listen for search field value change
        this.columnsFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterColumns();
            });
    }

    setupMultiSelectFamilyTreeProviders() {
        // load the initial list
        this.filteredFamilyTreeProviders.next(this.activePrescribers.slice());

        // listen for search field value change
        this.familyTreeProvidersFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterFamilyTreeProviders();
            });

        // anytime the familyTreeProviders value changes, we want to update our live columnlist
        this.familyTreeProviders.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.calculateColumnAndProviderSettings();
            });
    }

    setupMultiSelectSuperviseesProviders() {
        // load the initial list
        this.filteredSuperviseesProviders.next(this.activeProviders.slice());

        // listen for search field value change
        this.superviseesProvidersFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterSuperviseesProviders();
            });

        // anytime the value changes, we want to update our live columnlist
        this.superviseesProviders.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.calculateColumnAndProviderSettings();
            });
    }

    setupSelectSupervisorProviders() {
        // load the initial list
        this.filteredSupervisorProviders.next(this.activeProviders.slice());

        // listen for search field value change
        this.supervisorProviderFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterSupervisorProviders();
            });

        // anytime the value changes, we want to update our live columnlist
        this.supervisorProvider.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.calculateColumnAndProviderSettings();
            });
    }

    setupSelectProject() {
        // load the initial list
        this.filteredProjects.next(this.projects.slice());

        // listen for search field value change
        this.projectFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterProjects();
            });

        // anytime the value changes, we want to update our live columnlist
        // this.project.valueChanges
        //     .pipe(takeUntil(this._onDestroy))
        //     .subscribe(() => {
        //         this.onProjectChange();
        //     });
    }

    filterProjects() {
        if (!this.projects) {
            return;
        }
        // get the search keyword
        let search = this.projectFilterCtrl.value;
        if (!search) {
            this.filteredProjects.next(this.projects.slice());
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the projects
        this.filteredProjects.next(
            this.projects
                .filter(proj => proj.first_name_lowercase.indexOf(search) > -1 || proj.last_name.toLowerCase().indexOf(search) > -1)
        );
    }

    filterColumns() {
        if (!this.allColumnProvidersInOfficeKey) {
            return;
        }
        // get the search keyword
        let search = this.columnsFilterCtrl.value;
        console.log(search);
        if (!search) {
            this.filteredColumns.next(this.allColumnProvidersInOfficeKey.slice());
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the banks
        this.filteredColumns.next(
            this.allColumnProvidersInOfficeKey.filter(col => col.ColumnHeading.toLowerCase().indexOf(search) > -1)
        );
    }

    filterFamilyTreeProviders() {
        if (!this.activePrescribers) {
            return;
        }

        let search = this.familyTreeProvidersFilterCtrl.value;
        if (!search) {
            this.filteredFamilyTreeProviders.next(this.activePrescribers.slice());
            return;
        } else {
            search = search.toLowerCase();
        }

        this.filteredFamilyTreeProviders.next(
            this.activePrescribers.filter(prov => prov.FullName.toLowerCase().indexOf(search) > -1)
        );
    }

    filterSuperviseesProviders() {
        if (!this.activeProviders) {
            return;
        }

        let search = this.superviseesProvidersFilterCtrl.value;
        const office_code = Number(this.userCreate.controls['office_code'].value);

        if (!search) {
            this.filteredSuperviseesProviders.next(this.activeProviders.slice().filter(prov => prov.LicenseKey === office_code));
            return;
        } else {
            search = search.toLowerCase();
        }

        this.filteredSuperviseesProviders.next(
            this.activeProviders.filter(prov => prov.LicenseKey === office_code && prov.FullName.toLowerCase().indexOf(search) > -1)
        );
    }

    filterSupervisorProviders() {
        if (!this.activeProviders) {
            return;
        }

        let search = this.supervisorProviderFilterCtrl.value;
        const office_code = Number(this.userCreate.controls['office_code'].value);

        if (!search) {
            this.filteredSupervisorProviders.next(this.activeProviders.slice().filter(prov => prov.LicenseKey === office_code));
            return;
        } else {
            search = search.toLowerCase();
        }

        this.filteredSupervisorProviders.next(
            this.activeProviders.filter(prov => prov.LicenseKey === office_code && prov.FullName.toLowerCase().indexOf(search) > -1)
        );
    }

    clearSupervisees() {
        // clear the superviseesProviders control
        this.superviseesProviders.setValue([]);
    }

    clearFamilyTreeProviders() {
        // clear the familyTreeProviders control
        this.familyTreeProviders.setValue([]);
    }

    clearSupervisor() {
        // clear the supervisorProvider control
        this.supervisorProvider.setValue(null);
    }

    initColumnAndProviderSuggestions() {
        // disable all checkboxes if all is checked
        if (this.columnSettings.controls['all'].value) {
            // uncheck hide_future_columns if all is unchecked
            this.columnSettings.controls['hide_future_columns'].setValue(false);
        } else {
            // check hide_future_columns if all is unchecked
            this.columnSettings.controls['hide_future_columns'].setValue(true);
        }

        // if this role requires family tree, clear and enable family tree providers
        if (this.columnSettings.controls['others_in_family_tree'].value) {
            this.familyTreeProviders.setValue([]);
            this.familyTreeProviders.enable();
        } else {
            this.familyTreeProviders.setValue([]);
            this.familyTreeProviders.disable();
        }

        // if this role requires supervisees, clear and enable supervisees providers
        if (this.columnSettings.controls['supervisees'].value) {
            this.superviseesProviders.setValue([]);
            this.superviseesProviders.enable();
        } else {
            this.superviseesProviders.setValue([]);
            this.superviseesProviders.disable();
        }

        // if this role requires supervisor, clear and enable supervisor provider
        if (this.columnSettings.controls['supervisor'].value) {
            this.supervisorProvider.setValue(null);
            this.supervisorProvider.enable();
        } else {
            this.supervisorProvider.setValue(null);
            this.supervisorProvider.disable();
        }

        this.calculateColumnAndProviderSettings();
    }

    async loadAMDSettingsInParallel() {
        const requests = [];
        const base_url = environment.amdUsersBaseUrl;
        const params = new HttpParams()
            .set('password', 'Clarity9404');
        const params_133003 = new HttpParams()
            .set('password', 'Clarity9404').set('office_code', '133003');
        const params_138325 = new HttpParams()
            .set('password', 'Clarity9404').set('office_code', '138325');
        // load settings from AMD API
        requests.push(
            this.http.get(`${base_url}settings/ehr-preferences-templates`, {observe: 'response', params: params_133003}).toPromise());
        requests.push(
            this.http.get(`${base_url}settings/ehr-preferences-templates`, {observe: 'response', params: params_138325}).toPromise());
        requests.push(
            this.http.get(`${base_url}settings/columns`, {observe: 'response', params: params_133003}).toPromise());
        requests.push(
            this.http.get(`${base_url}settings/columns`, {observe: 'response', params: params_138325}).toPromise());
        requests.push(
            this.http.get(`${base_url}settings/providers`, {observe: 'response', params: params_133003}).toPromise());
        requests.push(
            this.http.get(`${base_url}settings/providers`, {observe: 'response', params: params_138325}).toPromise());

        // load settings from DB
        requests.push(
            this.http.get(`${base_url}settings`, {observe: 'response', params: params}).toPromise());

        let results;
        try {
            results = await Promise.all(requests);
        } catch (error) {
            console.error('Error loading AMD settings:', error);
            this.toastsService.showSnackBar('Error loading AMD settings, please try again later', 'error', 5000);
            return;
        }

        this.ehrPreferencesTemplates = results[0].body['ehr_preferences_templates'].concat(results[1].body['ehr_preferences_templates']);
        this.columns = results[2].body['columns'].concat(results[3].body['columns']);
        this.providers = results[4].body['providers'].concat(results[5].body['providers']);
        // iterate over results and set the values

        // TODO split these up to run faster
        const result = results[6];
        this.departments = result.body['departments'];
        // TODO put these roles as a dropdown for HR so we can trust entirely and automate onboarding
        this.roles = result.body['roles'];
        this.roles.sort((a, b) => a.RoleName.localeCompare(b.RoleName));

        this.role_to_columns = result.body['role_to_columns'];
        this.hloc_columns = result.body['hloc_columns'];
        this.users = result.body['users'];

        this.column_providers = result.body['column_providers'];

        this.column_providers.sort((a, b) => a.FullName.localeCompare(b.FullName));

        // find all unique Provider_UIDs in column_providers, and then map them to providers array with object that has Provider_UID and FullName
        const uniqueProviders = [...new Set(this.column_providers.map(provider => provider.Provider_UID))];
        // remove any provider_UID that exists within this.users['clinicalproviderid']
        // unassignedProviders will be used to set new user's clinicalproviderid
        const userProviderUids = this.users.map(user => user.clinicalproviderid);
        const filteredProviders = uniqueProviders.filter(providerUid => !userProviderUids.includes(providerUid));
        this.unassignedProviders = filteredProviders.map(providerUid => {
            const provider = this.column_providers.find(prov => prov.Provider_UID === providerUid);
            return {
                Provider_UID: provider.Provider_UID,
                FullName: provider.FullName,
                LicenseKey: provider.LicenseKey,
            };
        });

        // determine all providers with EMRActiveAt is not null
        // remove duplicate Provider_UIDs
        // and lastly map it as {Provider_UID, FullName, LicenseKey}
        // this will be used with provider settings and generate providerlist for new user request
        this.activeProviders = this.column_providers.filter(provider => provider.EMRActiveAt !== null);
        this.activeProviders = this.activeProviders.filter((provider, index, self) =>
                index === self.findIndex((p) => (
                    p.Provider_UID === provider.Provider_UID
                ))
        );
        this.activeProviders = this.activeProviders.map(provider => {
            return {
                Provider_UID: provider.Provider_UID,
                FullName: provider.FullName,
                LicenseKey: provider.LicenseKey,
                Type: provider.Type,
            };
        });

        // set activePrescribers where Type in 'NP', 'PA', 'PSYCHIATRIST'
        this.activePrescribers = this.activeProviders.filter(provider => {
            return provider.Type
                && (provider.Type.toUpperCase() === 'NP' || provider.Type.toUpperCase() === 'PA' || provider.Type.toUpperCase() === 'PSYCHIATRIST');
        });

        this.setupMultiSelectColumns();
        this.setupMultiSelectFamilyTreeProviders();
        this.setupMultiSelectSuperviseesProviders();
        this.setupSelectSupervisorProviders();

        this.initialLoadComplete = true;
    }

    createUser() {
        if (this.userCreate.invalid) {
            console.log('Invalid create user form');
            return;
        }

        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = false;
        dialogConfig.disableClose = true;
        dialogConfig.width = '400px';
        dialogConfig.data = {};
        this.openConfirmDialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

        this.openConfirmDialogRef.afterClosed().subscribe(async confirmed => {
            if (confirmed) {
                await this.runSteps();
            }
        });
    }

    async runSteps() {
        this.globalService.saving = true;
        // run sequence of steps to create user, update EHR preferences, and update related users
        let new_user_id = null;
        this.steps = [
            {
                label: 'Create User',
                completed: false,
                error: null,
                message: '',
                action: async () => {
                    const new_user = await this.createAmdUser();
                    new_user_id = new_user['id'];
                    console.log(new_user, new_user_id);

                    if (!new_user_id) {
                        throw new Error('Failed to create user, no user ID returned');
                    }
                },
            },
            {
                label: 'Update EHR Preferences',
                completed: false,
                error: null,
                message: '',
                action: async () => {
                    const office_code = this.userCreate.controls['office_code'].value;
                    const user_id = new_user_id;
                    const template_id = this.ehrPreferencesTemplateCtrl.value;

                    if (!template_id) {
                        return 'No EHR preferences template matches this role, skipping this step';
                    }
                    const result = await this.updateEhrPreferencesTemplateForNewUser(office_code, user_id, template_id);
                    console.log(result);
                },
            },
            {
                label: 'Update Affected Users',
                completed: false,
                error: null,
                message: '',
                action: async () => {
                    // TODO update affected users, such as family tree, supervisor, others in same role, etc
                    // skip this step if it's not needed
                    const shouldUpdateRelatedUsers = this.columnSettings.controls['others_in_family_tree'].value ||
                        this.columnSettings.controls['others_in_same_role'].value || this.columnSettings.controls['supervisor'].value;
                    if (!shouldUpdateRelatedUsers) {
                        return 'No related users to update, skipping this step';
                    }
                    const results = await this.updateExistingUsersWithNewUser();
                    console.log(results);
                },
            }
        ];

        // Execute each step in sequence
        for (const step of this.steps) {
            console.log(`Executing step: ${step.label}`);
            try {
                const message = await step.action();
                step.completed = true;
                if (message) {
                    step.message = message;
                }
                console.log(`${step.label} completed successfully.`);
            } catch (error) {
                step.error = error.error.error;
                console.log(`${step.label} failed, exiting early: ${error.message}`);
                break;
            }
        }

        this.globalService.saving = false;
        console.log(this.steps);

        const hasError = this.steps.some(step => step.error);
        if (hasError) {
            this.toastsService.showSnackBar('Some steps failed, please check the console for details', 'error', 5000);
        } else {
            this.toastsService.showSnackBar('User created successfully', 'success', 5000);
            // TODO if no errors, reset?
            this.resetUserCreateForm();
        }
    }

    updateEhrPreferencesTemplateForNewUser(office_code, user_id, template_id) {
        const payload = {
            password: 'Clarity9404',
            office_code: office_code,
            user_id: user_id,
            template_id: template_id,
        };
        return this.http.put('https://amd-users-ozzijyvlya-uc.a.run.app/user/ehr-preferences-template', payload).toPromise();
    }

    async createAmdUser() {
        const defaultSettings = {
            'id': 0,
            'edicontact': false,
            'expirationdate': null,
            'emergencyaccess': false,
            'scheduleroverridepin': null,
            'restoredeleted': false,
            'forcechanges': false, // TODO since UI doesn't verify, keep this false for now
            'ehrlimitedpatientaccess': false,
            'status': 'A',
            'purchasinguser': false,
            'cbokeylist': [],
        };

        // combine defaultSettings with rawvalue from userCreate form
        const new_user = { ...defaultSettings, ...this.userCreate.getRawValue(), ...this.columnAndProviderSettings.getRawValue() };

        const payload = {
            password: 'Clarity9404',
            office_code: this.userCreate.controls['office_code'].value,
            user: new_user
        };

        return this.http.post(environment.amdUsersBaseUrl + 'user', payload, {
            headers: {
                'Content-Type': 'application/json',
            }
        }).toPromise();
    }

    getFamilyTreeUsers(familyTreeProviders) {
        // get users of family tree members
        // familyTreeProviders is an array of objects with FullName and Provider_UID
        // we need to find the user IDs of these providers in this.users
        const familyTreeUsers = [];
        familyTreeProviders.forEach(provider_id => {
            const match = this.users.find(user => user.clinicalproviderid === provider_id);
            if (match) {
                familyTreeUsers.push(match);
            } else {
                console.warn(`No user found for Provider ID ${provider_id} in AMD`);
            }
        });
        return familyTreeUsers;
    }

    getOthersInSameRoleUsers(roleId) {
        // get users of others in same role
        // roleId is the ID of the role
        // we need to find the user IDs of these providers in this.users
        const othersInSameRoleUsers = [];
        this.users.forEach(user => {
            if (user.roleid === roleId) {
                othersInSameRoleUsers.push(user);
            }
        });
        return othersInSameRoleUsers;
    }

    calculateAffectedUsers() {
        const family_tree_users = this.columnSettings.controls['others_in_family_tree'].value
            ? this.getFamilyTreeUsers(this.familyTreeProviders.value) : [];
        const others_in_same_role_users = this.columnSettings.controls['others_in_same_role'].value
            ? this.getOthersInSameRoleUsers(this.userCreate.controls['roleid'].value) : [];
        const supervisor_user = this.supervisorProvider.value ?
            this.users.find(user => user.clinicalproviderid === this.supervisorProvider.value) : null;

        // combine all user IDs into a single array and deduplicate, supervisor can be undefined so be careful
        this.affectedUsers = Array.from(new Set([
            ...family_tree_users,
            ...others_in_same_role_users,
            supervisor_user
        ].filter(id => id !== null)));
    }

    async updateExistingUsersWithNewUser() {
        const new_user_provider_id = this.userCreate.controls['clinicalproviderid'].value;
        const new_user_column_id = this.allColumnProvidersInOfficeKey
            .find(col => col.Provider_UID === new_user_provider_id)?.ColumnHeading_UID;

        const promises = this.affectedUsers.map(user => {
            const payload = {
                password: 'Clarity9404',
                office_code: this.userCreate.controls['office_code'].value,
                new_user_column_id: new_user_column_id,
                new_user_provider_id: new_user_provider_id,
                affected_user_id: user.id, // this will be a single user ID to update
            };
            return this.http.put('https://amd-users-ozzijyvlya-uc.a.run.app/user/update', payload).toPromise();
        });

        return await Promise.all(promises);
    }

    completeUserDetailsStep() {
        this.updateEhrPreferencesTemplateFromRole();
        this.initColumnAndProviderSuggestions();

        this.stepperRef.next();
    }

    completeSettingsStep() {
        this.calculateAffectedUsers();

        this.stepperRef.next();
    }

    prefill() {
        // prefill the userCreate form based on the selected project
        if (!this.project.value) {
            this.toastsService.showSnackBar('Please select a project to prefill user details', 'error', 5000);
            return;
        }

        const selectedProject = this.project.value;
        console.log('Selected project for prefill:', selectedProject);
        // if location has the word 'arlington', set office_code to 138325, otherwise set it to 133003
        const officeCode = selectedProject.location.toLowerCase().includes('arlington') ? 138325 : 133003;

        // if project.department is psychiatry, set department to the department with name 'Psychiatry'
        // if project.department is psychological services, set department to the department with name 'Therapy'
        let departmentId;
        if (officeCode === 133003) {
            if (selectedProject.department.toLowerCase() === 'psychiatry') {
                departmentId = this.departments.find(dept => dept.LicenseKey === officeCode && dept.DepartmentDescription.toLowerCase() === 'psychiatry')?.Department_UID;
            } else if (selectedProject.department.toLowerCase() === 'psychological services') {
                departmentId = this.departments.find(dept => dept.LicenseKey === officeCode && dept.DepartmentDescription.toLowerCase() === 'psychological services')?.Department_UID;
            } else if (selectedProject.department.toLowerCase() === 'operations') {
                departmentId = this.departments.find(dept => dept.LicenseKey === officeCode && dept.DepartmentDescription.toLowerCase() === 'operations')?.Department_UID;
            } else {
                departmentId = this.departments.find(dept => dept.LicenseKey === officeCode && dept.DepartmentDescription.toLowerCase() === 'office')?.Department_UID;
            }
        } else {
            // 138325 key
            departmentId = this.departments.find(dept => dept.LicenseKey === officeCode && dept.DepartmentDescription.toLowerCase() === 'office')?.Department_UID;
        }

        // create fullname using first_name and last_name from project
        const fullName = `${selectedProject.first_name} ${selectedProject.last_name}`;

        // create email using first_name and last_name from project, first initial plus last name @claritychi.com
        const email = `${selectedProject.first_name.charAt(0).toLowerCase()}${selectedProject.last_name.toLowerCase()}@claritychi.com`;

        let role_uid = null;
        if (selectedProject.department.toLowerCase() === 'reimbursement') {
            role_uid = this.roles.find(role => role.LicenseKey === officeCode && role.RoleName.toLowerCase() === 'reimbursement')?.Role_UID;
        } else if (selectedProject.department.toLowerCase() === 'marketing') {
            role_uid = this.roles.find(role => role.LicenseKey === officeCode && role.RoleName.toLowerCase() === 'marketing')?.Role_UID;
        } else if (selectedProject.department.toLowerCase() === 'human resources') {
            role_uid = this.roles.find(role => role.LicenseKey === officeCode && role.RoleName.toLowerCase() === 'admin')?.Role_UID;
        } else if (selectedProject.department.toLowerCase() === 'information technology') {
            role_uid = this.roles.find(role => role.LicenseKey === officeCode && role.RoleName.toLowerCase() === 'admin')?.Role_UID;
        } else {
            // if project.sub_department is 'PHP/IOP', set role to role in office code with label 'PHP/IOP Therapist'
            if (selectedProject?.sub_department?.toLowerCase() === 'php/iop' && selectedProject?.title.includes('intake')) {
                role_uid = this.roles.find(role => role.LicenseKey === officeCode && role.RoleName.toLowerCase() === 'php/iop intake')?.Role_UID;
            } else if (selectedProject?.sub_department?.toLowerCase() === 'php/iop' && selectedProject?.title.includes('therapist')) {
                role_uid = this.roles.find(role => role.LicenseKey === officeCode && role.RoleName.toLowerCase() === 'php/iop therapist')?.Role_UID;
            } else if (selectedProject?.department?.toLowerCase() === 'operations' && selectedProject?.title.includes('tms')) {
                role_uid = this.roles.find(role => role.LicenseKey === officeCode && role.RoleName.toLowerCase() === 'tms coordinator')?.Role_UID;
            } else {
                // determine role based on projectsService.department_roles[selectedProject.department] which is an array of objects with label and value, fine the object with value equal to selectedProject.role
                role_uid = this.projectsService.department_roles[selectedProject.department]
                    .find(role => role.value === selectedProject.role)?.amd_role[officeCode];
            }
        }
        // const role = this.roles.find(r => r.Role_UID === role_uid);

        // find a provider in allProviders
        const nameToCompare = `${selectedProject.last_name},${selectedProject.first_name}`.toLowerCase();
        const found_provider = this.unassignedProviders.slice()
            .filter(provider => provider.LicenseKey === officeCode).find(
                provider => provider.FullName.toLowerCase().trim() === nameToCompare
            );

        // if found_provider is not null, set clinicalproviderid to its Provider_UID, otherwise set it to null
        const clinicalProviderId = found_provider ? found_provider.id : null;

        // set the userCreate form values
        this.userCreate.patchValue({
            fullname: fullName,
            email: email,
            office_code: officeCode.toString(),
            departmentid: departmentId,
            roleid: role_uid,
            clinicalproviderid: clinicalProviderId,
        });

        // force reinitialization of form fields
        this.onChangeOfficeCode(false);
        this.generateUsername();
    }
}
